import { Component, input } from '@angular/core';
import { BadgeComponent } from '../badge/badge.component';
import { type OccurrenceListCountVariant, type OccurrenceListItem, type OccurrenceListLayout } from './occurrence-list.model';

/**
 * Headline count card + scrollable date/time/badge row list.
 *
 * Shared between two use cases that both need "here's a set of dated occurrences with a
 * status badge each": previewing a recurring series before it's created (green/red
 * availability badges) and viewing the occurrences of an already-created series (status
 * badges: pagado / pendiente / cancelado / finalizado). Callers own all domain mapping —
 * this component only renders whatever `items` it's given.
 */
@Component({
  selector: 'lib-occurrence-list',
  imports: [BadgeComponent],
  templateUrl: './occurrence-list.component.html',
  styleUrls: [
    '../../tokens/colors.css',
    './occurrence-list.component.css',
  ],
})
export class OccurrenceListComponent {
  /** Label above the headline count (e.g. "Partidos generados"). */
  title = input.required<string>();

  /** Headline number shown in the count card. */
  count = input<number>(0);

  /** Color theme for the count card. */
  countVariant = input<OccurrenceListCountVariant>('emerald');

  /** 'block' (default): label above a large number. 'inline': "Label: N" on one line — use in tight spaces. */
  layout = input<OccurrenceListLayout>('block');

  items = input<OccurrenceListItem[]>([]);

  /** Shown instead of the list when `items` is empty. */
  emptyMessage = input<string>('No hay ocurrencias para mostrar.');
}
